import { useRegulatoryClassificationQuery } from "@api/regulatory/regulatoryClassification/useRegulatoryClassification";
import ResetIcon from "@images/pressList/icon-reload.svg";
import SearchFilterTag from "@PressListContainer/shared/components/SearchFilterTag/SearchFilterTag";
import { useRegulatoryListFilterState } from "@stores/regulatoryList";

import {
  EDITOR_INFO_CODE,
  STATUS_FILTER,
  StatusCode,
} from "./constants/filterCode.constants";
import * as S from "./RegulatorySearchResult.style";

interface SearchType {
  [key: string]: string | undefined;
}

const RegulatorySearchResult = () => {
  const [regulatoryListFilter, setRegulatoryListFilter] =
    useRegulatoryListFilterState();
  const { data: regulatoryClassificationData } =
    useRegulatoryClassificationQuery();

  const { search, regulatoryListDataTotal, classification, status } =
    regulatoryListFilter;

  const isSearch =
    (search && !!Object.keys(search).length) ||
    !!classification.length ||
    !!status.length;

  const handleDeleteClassification = (currentCode: string) => {
    setRegulatoryListFilter({
      ...regulatoryListFilter,
      classification: classification.filter(
        (filterCode) => filterCode !== currentCode,
      ),
      page: 1,
    });
  };

  const handleDeleteStatus = (currentCode: string) => {
    const deleteStatusFilter = status.filter(
      (filterCode) => filterCode !== currentCode,
    );

    setRegulatoryListFilter({
      ...regulatoryListFilter,
      status: deleteStatusFilter,
      page: 1,
    });
  };

  const handleDeleteSearch = (currentKey: string) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { [currentKey]: currentSearch, ...otherSearch } =
      search as SearchType;

    setRegulatoryListFilter({
      ...regulatoryListFilter,
      search: {
        ...otherSearch,
      },
      page: 1,
    });
  };

  const handleResetFilter = () => {
    setRegulatoryListFilter({
      ...regulatoryListFilter,
      search: {},
      classification: [],
      status: [],
    });
  };

  const handleCheckIdInfoSearch = (key: string, value: string) => {
    if (key !== "idInfo") return value;

    const idValue = value.replace(/#/g, "");

    return `#${idValue}`;
  };

  return (
    <>
      {isSearch && (
        <S.SearchResult>
          <S.SearchResultText>Search Results for</S.SearchResultText>
          {search &&
            Object.entries(search).map(
              ([key, value]) =>
                value && (
                  <SearchFilterTag
                    key={key}
                    type="result"
                    text={handleCheckIdInfoSearch(key, value)}
                    isAllInfo={!!(key === "allInfo" || key === "allEditorInfo")}
                    isUserInput
                    code={EDITOR_INFO_CODE[key]}
                    onClickDeleteButton={() => handleDeleteSearch(key)}
                  />
                ),
            )}
          {classification.map((code) => (
            <SearchFilterTag
              key={code}
              type="result"
              text={
                code === ""
                  ? "None"
                  : regulatoryClassificationData?.[code] || ""
              }
              isAllInfo={false}
              isRegulatoryClassification
              onClickDeleteButton={() => handleDeleteClassification(code)}
            />
          ))}
          {status &&
            status.map((statusCode) => (
              <SearchFilterTag
                key={statusCode}
                type="result"
                text={STATUS_FILTER[statusCode as StatusCode]}
                isAllInfo={false}
                code={statusCode}
                onClickDeleteButton={() => handleDeleteStatus(statusCode)}
              />
            ))}
          <S.SearchTotalCount>({regulatoryListDataTotal})</S.SearchTotalCount>
          <S.ResetButton onClick={handleResetFilter}>
            <img src={ResetIcon} width={10} alt="filter reset icon" />
            <S.ResetButtonText>Filter Reset</S.ResetButtonText>
          </S.ResetButton>
        </S.SearchResult>
      )}
    </>
  );
};

export default RegulatorySearchResult;
